import {useEffect, useState} from "react";
import {BreadCrumbs} from "../../../components/open/pages";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {ThinAddIcon, ThinEditIcon, ThinTrashIcon} from "../../../components/icons/material-icons";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import {RemoveModal} from "../../../components/template/remove-modal";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {Link, useNavigate} from "react-router-dom";
import {AdminsAddEditConsentModal} from "./add-edit-consent";

interface consentInterface {
    id: number,
    title: string,
    isAvailableForAll: 0 | 1,
    class: string,
    expiresAt: string,
    createdAt: string,
    total: number,
}

export const AdminsConsentsListScreen = () => {
    const [list, setList] = useState<consentInterface[]>([]);
    const [loaded, setLoaded] = useState(false);
    const [canAdd,setCanAdd] = useState(false);
    const navigate = useNavigate();
    const fetchList = () => {
        PostJSON(
            Apis.server + '/core/admins/consents/list',
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: consentInterface[] | null,
                canAdd:boolean,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    else if(d.reason === 'access'){
                        ShowSnackbar(
                            'شما به این بخش دسترسی ندارید.',
                            'باشه',
                            5000,
                        );
                        navigate('/admins',{replace:true});
                    }
                    return;
                }
                setLoaded(true);
                setList(d.list === null ? [] : d.list);
                setCanAdd(d.canAdd);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "رضایت‌نامه ها | اتوماسیون";
        fetchList();
    }, []);
    const [addEditModal, setAddEditModal] = useState({
        show: false,
        id: 0,
        edit: false,
    });
    const [removeModal, setRemoveModal] = useState({
        show: false,
        id: 0,
        title: '',
    });
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'رضایت‌نامه ها', url: '/admins/consents'},
            ]}/>
            {
                loaded ?
                    <div className="container" data-aos={"fade-up"} data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>رضایت‌نامه ها</b>
                                {
                                    canAdd ?
                                        <button onClick={() => setAddEditModal({
                                            id: 0,
                                            edit: false,
                                            show: true,
                                        })}>
                                            <ThinAddIcon/>
                                            <span>رضایت‌نامه جدید</span>
                                        </button> : null
                                }
                            </div>
                            <table className="table open-table table-striped table-hover table-bordered">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>عنوان</th>
                                    <th>نوع</th>
                                    <th>انقضا</th>
                                    <th>تعداد ثبت‌نام</th>
                                    <th>امکانات</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    list.map((s, i) =>
                                        <tr key={"QQs39ruWsj22239" + i}>
                                            <td>{CurrencyFormat(i + 1)}</td>
                                            <td>
                                                <Link to={`/admins/consents/view/${s.id}`}>
                                                    {s.title}
                                                </Link>
                                            </td>
                                            <td>{s.isAvailableForAll ? 'همگانی' : (s.class !== '' ? ("مخصوص " + s.class) : 'افراد خاص')}</td>
                                            <td>{StringDigitsConvertToPersian(GregorianToPersian(s.expiresAt.split(' ')[0]).replaceAll('-', '/'))}</td>
                                            <td>{CurrencyFormat(s.total)}</td>
                                            <td>
                                                {
                                                    canAdd ?
                                                        <div style={{
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            gap: 5
                                                        }}>
                                                            <button className="open-tooltip"
                                                                    onClick={() => setAddEditModal({
                                                                        id: s.id,
                                                                        show: true,
                                                                        edit: true,
                                                                    })}>
                                                                <i>ویرایش</i>
                                                                <ThinEditIcon/>
                                                            </button>
                                                            <button className="open-tooltip"
                                                                    onClick={() => setRemoveModal({
                                                                        title: s.title,
                                                                        show: true,
                                                                        id: s.id,
                                                                    })}>
                                                                <i>حذف</i>
                                                                <ThinTrashIcon/>
                                                            </button>
                                                        </div> : '-'
                                                }
                                            </td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div> : null
            }
            <AdminsAddEditConsentModal
                active={addEditModal.show}
                closeHandler={() => setAddEditModal(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                onDone={() => {
                    ShowProgressLoading();
                    fetchList();
                }}
                isEdit={addEditModal.edit}
                consentId={addEditModal.id}
            />
            <RemoveModal
                active={removeModal.show}
                closeHandler={() => setRemoveModal(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                title={"حذف پرداخت"}
                desc={"آیا مطمئن هستید که می‌خواهید " + removeModal.title + " را حذف کنید؟"}
                onRemove={() => {
                    const x = {...removeModal};
                    ShowProgressLoading();
                    PostJSON(
                        Apis.server + '/core/admins/consents/remove',
                        {
                            id: x.id,
                        },
                        true,
                        (d: {
                            result: string,
                            reason: string | undefined,
                        }) => {
                            HideProgressLoading();
                            if (d.result !== 'OK') {
                                if (d.reason === 'login')
                                    AuthRedirectAdmins();
                                return;
                            }
                            ShowSnackbar(
                                'رضایت‌نامه حذف گردید.',
                                'باشه',
                                5000,
                            );
                            ShowProgressLoading();
                            fetchList();
                        },
                        () => {
                        },
                        AuthRedirectAdmins,
                    ).then(void 0);
                }}
            />

        </>
    );
};